import React, { Fragment } from 'react';

import { Button, Dialog, Grid, } from '@mui/material'
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

const LocationMap = ({ maxWidth, button, buttonClass }) => {
    const [open, setOpen] = React.useState(false);

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }


    const DialogTitle = ((props) => {
        const { onClose } = props;
        return (
            <MuiDialogTitle>
                {onClose ? (
                    <IconButton className='event-close-btn' aria-label="close" onClick={onClose}>
                        <i className="ti-close"></i>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });


    return (
        <Fragment>
            <Button
                className={`btn ${buttonClass}`}
                onClick={handleClickOpen}
                style={{ fontSize: '22px' }}>
                {button}
                Ver ubicación
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                className="modalWrapper quickview-dialog"
                maxWidth={maxWidth}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}> </DialogTitle>
                <Grid className="modalBody modal-body">
                    <Grid className="modalBody modal-body">
                    <iframe title="Estacionamiento Zacapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.667455138159!2d-99.09938341776865!3d19.25331943554574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce03fbe78d7a2b%3A0xfd97c5dc47ca17e8!2sAv%20Hermenegildo%20Galeana%20260%2C%20Xaltocan%2C%20Xochimilco%2C%2016090%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX!5e0!3m2!1ses-419!2smx!4v1761536203696!5m2!1ses-419!2smx"></iframe>
                    </Grid>
                </Grid>
            </Dialog>
        </Fragment>
    );
}
export default LocationMap


